import { Link } from "react-router-dom";
import { Check } from "@phosphor-icons/react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { fmtCurrency } from "@/lib/format";

function formatFechaEs(iso) {
  if (!iso) return "";
  try {
    const d = new Date(`${iso}T00:00:00`);
    return d.toLocaleDateString("es-EC", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  } catch {
    return iso;
  }
}

export default function AgendaCard({ item, tone }) {
  const showPromesaTexto =
    item.promesa_fecha && item.promesa_fecha !== item.promesa_fecha_iso;

  return (
    <Card
      className={`border ${tone} transition-all hover:shadow-md`}
      data-testid={`agenda-card-${item.id}`}
    >
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <Link
              to={`/deudores/${item.id}`}
              className="font-medium hover:underline truncate block"
            >
              {item.cliente_nombre}
            </Link>
            <div className="text-xs text-muted-foreground mt-0.5 capitalize">
              {formatFechaEs(item.promesa_fecha_iso)}
              {showPromesaTexto && (
                <span className="ml-1 italic">· “{item.promesa_fecha}”</span>
              )}
            </div>
          </div>
          <div className="text-right shrink-0">
            <div className="font-mono font-semibold">
              {fmtCurrency(item.promesa_monto)}
            </div>
            <div className="text-[11px] text-muted-foreground">
              Saldo {fmtCurrency(item.saldo_pendiente)}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 mt-3">
          {item.recordatorio_enviado && (
            <Badge
              variant="outline"
              className="rounded-full border-success/40 text-success"
              data-testid={`reminder-sent-${item.id}`}
            >
              <Check size={12} weight="bold" className="mr-1" />
              Recordatorio enviado
            </Badge>
          )}
          <Link to={`/deudores/${item.id}`} className="ml-auto">
            <Button
              variant="outline"
              size="sm"
              data-testid={`open-agenda-${item.id}`}
            >
              Gestionar
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
